// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__3Q6Gq","ball":"Switch_ball__1LuSQ"};